import { ChainActionTypes } from './actionTypes'

export const resetChainStore = () => ({ type: ChainActionTypes.chainReset })
